import { BgColorType } from "@/lib/types";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  className?: HTMLAttributes<HTMLSpanElement>["className"];
  id?: HTMLAttributes<HTMLSpanElement>["id"];
  padding?: CSSProperties["padding"];
  textAlign?: CSSProperties["textAlign"];
}>;

export default function Code({
  bgColor,
  children,
  className,
  id,
  padding,
  textAlign,
}: Props) {
  const styles: CSSProperties = {
    backgroundColor: bgColor
      ? `var(--color-background-${bgColor})`
      : "var(--color-background-elevated)",
    borderRadius: "var(--border-radius-xs)",
    color: "var(--color-text-secondary) !important",
    padding: padding ? `var(--spacing-${padding})` : "0 var(--spacing-sm)",
    fontFamily: "'Source Code Pro', monospace !important",
    fontWeight: 600,
    textAlign: textAlign || "start",
    whiteSpace: "pre-wrap",
    overflowX: "auto",
  };

  return (
    <code className={className} id={id} style={styles}>
      {children}
    </code>
  );
}
